export default __webpack_public_path__ + "static/media/06-icon-sprachen.96df97eb.svg";